import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';

export const buildUpdateAccountCompanyRequest = (
  accountId,
  companyId,
  companyData
) => [
  `${getAdminApiUrl()}/v1/accounts/${accountId}/companies/${companyId}`,
  {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(companyData),
  },
];
